// hooks/ContactFormContext.jsx
import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import { getUnreadMessagesCountContactForm } from "../services/contactformServices";

const ContactFormContext = createContext({
  unreadCountContactForm: 0,
  setUnreadCountContactForm: () => {},
  refresh: () => {},
});

export const ContactFormProvider = ({ userId, children, pollMs = 60000 }) => {
  const [unreadCountContactForm, setUnreadCountContactForm] = useState(0);
  const intervalRef = useRef(null);

  const refresh = useCallback(async () => {
    if (!userId) {
      setUnreadCountContactForm(0);
      return;
    }
    try {
      const count = await getUnreadMessagesCountContactForm(userId);
      setUnreadCountContactForm(Number(count || 0));
    } catch (e) {
      // console.error("[ContactFormContext] refresh error", e);
    }
  }, [userId]);

  useEffect(() => {
    let cancelled = false;

    // cleanup d’un éventuel ancien intervalle (si userId change)
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    const boot = async () => {
      await refresh();
      if (!cancelled && pollMs > 0) {
        intervalRef.current = setInterval(refresh, pollMs);
      }
    };

    if (userId) boot();
    else setUnreadCountContactForm(0);

    return () => {
      cancelled = true;
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [userId, pollMs, refresh]);

  return (
    <ContactFormContext.Provider
      value={{ unreadCountContactForm, setUnreadCountContactForm, refresh }}
    >
      {children}
    </ContactFormContext.Provider>
  );
};

export const useContactForm = () => useContext(ContactFormContext);
